/* eslint-disable prettier/prettier */
import { StyleSheet } from "aphrodite";

const Styles = StyleSheet.create({
  paddingRem: {
    paddingTop: "16px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "6px 6px 10px #0000001A",
    borderRadius: "12px",
    marginBottom: "15px",
    paddingBottom: "30px",
    width: "100%",
  },
  profileImg: {
    height: 22,
    width: 22,
    borderRadius: "50%",
    marginRight: ".5rem",
  },
  addNewFriend: {
    color: "#0000FF",
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 16,
  },
  link: {
    display: "flex",
    gap: 8,
    cursor: "pointer",
    alignItems: "center",
    padding: "5px",
  },
  inputContainer: {
    border: "1px solid #616161",
    padding: "8px",
    outline: "none",
    backgroundColor: "#E5E5E5",
    minWidth: 154,
  },
  profileImgContainer: {
    display: "flex",
    alignItems: "center",
  },
  paddingvertical: {
    paddingTop: "0.2rem",
    paddingBottom: "0.2rem",
  },
  stickyBanner: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    backgroundColor: "#F7F7F9",
  },
  nonStickyBanner: {
    top: 0,
    zIndex: 10,
    backgroundColor: "#F7F7F9",
    padding: "0px 20px",
  },
  searchContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: "700",
    fontSize: "10px",
    color: "#000000",
    width: "100%",
  },
  typography: {
    color: "#000000",
    marginBottom: 25,
    fontSize: 16,
    fontWeight: 600,
    lineHeight: "24px",
  },
  metaInfo: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
  },
  key: {
    color: "#8C8C8C",
    fontSize: "20px",
    fontWeight: 400,
  },
  value: {
    color: "#8C8C8C",
    fontSize: "40px",
    fontWeight: 400,
  },
  otherCount: {
    marginTop: "20px",
    marginRight: "20px",
  },
  tiles: {
    minWidth: "18%",
    minHeight: "50.998px",
    flexShrink: "0",
    borderRadius: "5.348px",
  },
  tilesForMobile: {
    minWidth: "20%",
    minHeight: "50.998px",
    flexShrink: "0",
    borderRadius: "5.348px",
  },
  text: {
    textAlign: "center",
    fontFamily: "Noto Sans",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "125%",
    paddingTop: "2px",
  },
  count: {
    textAlign: "center",
    fontFamily: "Noto Sans",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "125%",
    minWidth: "16.043px",
    height: "15.151px",
    flexShrink: "0",
  },
  rightContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%",
    fontSize: "14px",
    paddingTop: "15px",
    paddingRight: "5px",
    gap: 10,
    // border: "1px solid red",
    height: "100%",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      justifyContent: "flex-start",
      flexWrap: "wrap",
      gap: "10px",
      paddingRight: "0px",
    },
  },
  gridContainer: {
    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
  buttonstyle: {
    padding: "1rem",
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "3rem",
  },
});
export default Styles;
